module.exports = __webpack_public_path__ + "img/imagotipo-uc.8ba876c5.svg";